import { Grid, styled } from '@mui/material';

export const MainContainerGrid = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[400]}`,
  borderRadius: theme.shape.borderRadius,
}));
